module.exports = __webpack_public_path__ + "img/worksbot_img20022510.022ae65f.jpg";